<template>
    <div class="con-img-upload">
        <div class="img-upload con-input-upload" v-if="filename">
            <button type="button" class="btn-x-file" @click="onDelete">
                <i translate="translate" class="material-icons notranslate">clear</i>
            </button>
            <h4 class="text-archive"><span>{{filename}}</span></h4>
        </div>
        <div class="con-input-upload" v-else>
            <input type="file" style="z-index: 100;" id="file" v-if="uploadReady" ref="file" v-on:change="onChange()">
            <span class="text-input">{{title}}</span>
            <span class="input-progress" style="width: 0%;"></span>
            <i translate="translate" class="material-icons notranslate" style="text-align: right; position: absolute; width: 80%;">cloud_upload</i>
        </div>
    </div>
</template>

<script>
    export default {
        name: "custom-upload",
        props: {
            title: String,
            fileName: String,
            onChangeCallback: { type: Function },
            onDeleteCallback: { type: Function }
        },
        data (){
            return {
                filename: '',
                isUpload: false,
                uploadReady: true
            }
        },
        methods: {
            onChange() {
                let file = this.$refs.file.files[0];
                this.filename = file.name
                this.onChangeCallback(file, this.title)
                this.isUpload = true
            },
            onDelete(){
                let file = ''
                if (this.$refs.file !== undefined){
                    file = this.$refs.file.files[0]
                }

                this.isUpload = false
                this.filename = ''
                this.uploadReady = false
                this.$nextTick(() => {
                    this.uploadReady = true
                })

                this.onDeleteCallback(file, this.title)
            }
        },
        watch: {
            fileName: function () {
                this.filename = this.fileName
            }
        }
    }
</script>

<style lang="scss">
    .con-input-upload {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        height: 73px;
        text-align: left;
        margin: 0px;
        flex-direction: column;

        .text-input {
            text-align: left;
            width: 80%;
            display: block;
        }
    }

    .con-img-upload .img-upload {
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        float: left;
        background: rgba(0, 80, 0, .5);
        background: #fff;
        -webkit-box-shadow: 0 5px 20px 0 rgba(0, 0, 0, .1);
        box-shadow: 0 5px 20px 0 rgba(0, 0, 0, .1);
        -webkit-transition: all .3s ease;
        transition: all .3s ease;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        width: 100%;
        height: 73px;
        margin: 0;
        /*margin-left: 0;*/
        cursor: pointer;
    }
</style>